import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import Flow43_1Table from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const Flow43_1 = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("TRANSPORT_FOR_DEMOLITION_DISMANTLING") || "Transport for demolition/dismantling"}
        subDescription={t("TRANSPORT_FOR_DEMOLITION_DISMANTLING_DESC") || "This covers the transport needed to move workers, tools, or equipment required for the deconstruction or dismantling activity. It accounts for vehicle use, distances, and fuel consumption linked to reaching the site to perform C1 activities."}
        isNormal={true}
        number={"43.1"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`flow-43-1-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <Flow43_1Table productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default Flow43_1;

